import React from 'react';
import NavHeader from '../../components/NavHeader/NavHeader';
import ContactHero from '../../components/ContactHero/ContactHero';
import PageHelmet from '../../components/shared/PageHelmet';
import OurOffice from '../../components/OurOffice/OurOffice';
import LetsConnect from '../../components/LetsConnect/LetsConnect';
import MainFooter from '../../components/MainFooter/MainFooter';

const Contact = () => {
   return (
      <>
         <PageHelmet
            pageTitle="Contact Us"
            description="Get in touch with Harsoft Solutions, a software development company in Hyderabad, for web development, mobile app development, AI development services, and SaaS development."
            keywords="Contact Harsoft Solutions, Software Development Company Hyderabad"
            path="/contact"
         />
         <NavHeader/>
         <main>
            <ContactHero/>
            <LetsConnect
               badge="Contact Us"
               heading="Get in Touch"
               subtitle="Have a question or feedback? Fill out the form below, and we'll respond promptly!"
               submitLabel="Submit"
            />
            <OurOffice/>
         </main>
         <MainFooter/>
      </>
   );
};

export default Contact;